import { useState, useEffect } from "react";
import Slct from "../Slct";
import api from "../../services/api";
import { toast } from "react-toastify";
import useWrapper from "../../hooks/useWrapper";
import { Currency } from "../Input";
import Button from "../Button";
import DatePicker from "../DatePicker";
import ModalCustom from "./modal-template-default";
import Required from "../../components/Required";
import { validateForm } from "../../components/ValidateForm";
import useFormat from "../../hooks/utils/useFormat";
import Results from "../Results";
import { ceil2 } from "../../util/functions";
import { calculateFees } from "@entaoformouorg/formou-shared-functions";
import usePermission from "../../hooks/usePermission";

const ModalSlipManualPayment = props => {
  const { show, onHide, slip, updateSlip } = props;
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isWaitingResponse, setisWaitingResponse] = useState();
  const [mods, setmods] = useState();
  const [values, setvalues] = useState();
  const { me, config } = useWrapper();
  const { formatReal } = useFormat();
  const canManualPayment = usePermission("financialGroup", "paymentDown");

  const manualPayment = async () => {
    if (!canManualPayment) return;
    const _is_valid = validateForm(document.getElementById("manual_receive_container"));
    if (!_is_valid) return;
    setisWaitingResponse(true);
    try {
      const { data: _slip } = await api.put(
        `paymentslips/${slip.id}`,
        {
          status: "pago",
          payment_date: mods?.payment_date,
          value_paid: values?.total || 0,
          value_juros: (values?.fees || 0) - (mods?.discount_juros || 0),
          value_discount: mods?.discount || 0,
          method_payment: paymentMethod,
          user_id: me?.id,
          status_error: 0,
          typeLog: "manual_payment",
        },
        config,
      );
      toast.success("Pagamento Manual Cadastrado!");
      updateSlip({
        slip_id: slip?.id,
        update: {
          status: "Pago",
          value_paid: values?.total || 0,
          value_juros: (values?.fees || 0) - (mods?.discount_juros || 0),
          discount: mods?.discount || 0,
          method: methodFormat(paymentMethod),
          payment_date: mods?.payment_date,
          logs: _slip?.logBoletos || [],
        },
      });
    } catch (__err) {
      toast.error("Problemas ao efetuar pagamento manual!");
      console.error("__err", __err);
    } finally {
      closeModal();
      setisWaitingResponse(false);
    }
  };
  const closeModal = () => {
    onHide();
    setvalues();
    setmods();
    setPaymentMethod();
  };

  useEffect(() => {
    const _discount = slip?.discount || 0;
    const _tax = slip?.tax || 0;
    setmods({
      discount: _discount,
      tax: _tax,
      due_date: slip?.due_date,
      payment_date: new Date(),
    });
  }, [slip]);

  useEffect(() => {
    if (!!mods) {
      const _slip_value = slip?.value_raw - mods?.discount + mods?.tax || 0;
      const _fees = calculateFees({
        value: _slip_value,
        due_date: mods?.due_date,
        payment_date: mods?.payment_date,
      });
      setvalues({
        total: _slip_value + _fees - (mods?.discount_juros || 0),
        fees: _fees,
      });
    }
  }, [mods, slip?.value_raw]);

  const methodFormat = __method => {
    return __method === "boleto"
      ? "Boleto"
      : __method === "cartao"
        ? "Cartão"
        : __method === "pix"
          ? "PIX"
          : __method === "especie" || __method === "dinheiro"
            ? "Espécie"
            : "Outro";
  };

  return (
    <>
      <ModalCustom show={show} onHide={closeModal} id="manual_receive_container" disableClose={!!isWaitingResponse}>
        <ModalCustom.Header>
          <ModalCustom.Title>Recebimento Manual</ModalCustom.Title>
        </ModalCustom.Header>
        <ModalCustom.Body>
          <p className="small-label">
            Você está prestes a registrar um pagamento manual. Certifique-se de que todas as informações estão corretas.
          </p>
          <div className="mt-2">
            <label>
              Método de Pagamento <Required />
            </label>
            <Slct
              required={true}
              isDisabled={isWaitingResponse}
              value={paymentMethod}
              onChange={__ev => setPaymentMethod(__ev.value)}
              options={[
                { value: "especie", label: "Dinheiro em espécie" },
                { value: "pix", label: "PIX" },
                { value: "cartao", label: "Cartão de Crédito" },
              ]}
              placeholder="..."
            />
          </div>
          <div className="mt-2">
            <label>Desconto (Negociação)</label>
            <Currency
              value={mods?.discount || 0}
              isAllowed={__ev => {
                if (__ev <= slip?.value) {
                  return true;
                }
                toast.error(
                  `O Desconto não pode ser maior que o Valor do Pagamento.
                  (${formatReal(slip?.value || 0)}`,
                  {
                    toastId: "discount_error",
                  },
                );
              }}
              valueChange={__ev => {
                if (mods?.discount_juros > 0) {
                  toast.error("Ao alterar o Desconto (Negociação), o Desconto (Multa e Juros) será zerado.");
                }
                setmods({
                  ...mods,
                  discount: __ev || 0,
                  discount_juros: 0,
                });
              }}
            />
          </div>
          <div className="mt-2">
            <label>Taxas (Negociação)</label>
            <Currency value={mods?.tax || 0} valueChange={__ev => {}} disabled={true} />
          </div>
          <div className="mt-2">
            <label>
              Data do Pagamento <Required />
            </label>
            <DatePicker
              required={true}
              disabled={isWaitingResponse}
              selected={mods?.payment_date || ""}
              onChange={__ev => {
                if (__ev) {
                  setmods({
                    ...mods,
                    payment_date: __ev,
                  });
                }
              }}
            />
          </div>
          {values?.fees > 0 && (
            <div className="mt-2">
              <label>Desconto (Multa e Juros)</label>
              <Currency
                value={mods?.discount_juros || 0}
                isAllowed={__ev => {
                  if (ceil2(__ev) <= ceil2(values?.fees)) {
                    return true;
                  }
                  toast.error(
                    `O Desconto não pode ser maior que o total de Multa e Juros.
                    (${formatReal(values?.fees || 0)})`,
                    {
                      toastId: "discount_juros_error",
                    },
                  );
                }}
                valueChange={__ev => {
                  setmods({
                    ...mods,
                    discount_juros: __ev || 0,
                  });
                }}
              />
            </div>
          )}
          <div className="mt-4">
            <Results
              rows={[
                {
                  label: "Valor Inicial",
                  value: formatReal(slip?.value_raw || 0),
                  type: "dark",
                },
                {
                  label: "Desconto (Negociação)",
                  value: `- ${formatReal(mods?.discount || 0)}`,
                },
                {
                  label: "Taxas (Negociação)",
                  value: `+ ${formatReal(mods?.tax || 0)}`,
                },
                {
                  label: "Multa e Juros",
                  value: `+ ${formatReal(values?.fees || 0)}`,
                },
                ...(values?.fees > 0
                  ? [
                      {
                        label: "Desconto (Multa e Juros)",
                        value: `${formatReal(-1 * mods?.discount_juros || 0)}`,
                      },
                    ]
                  : []),
                {
                  label: <b>Valor Pago</b>,
                  value: <b>{formatReal(values?.total)}</b>,
                  type: "dark",
                },
              ]}
            />
          </div>
        </ModalCustom.Body>
        <ModalCustom.Footer>
          <Button disabled={isWaitingResponse} color="primary_ghost" onClick={closeModal}>
            Cancelar
          </Button>
          <Button
            disabled={isWaitingResponse || !canManualPayment}
            onClick={manualPayment}
            loading={isWaitingResponse}
            title={!canManualPayment ? "Você não tem permissão para realizar essa ação." : undefined}
          >
            Confirmar Pagamento Manual
          </Button>
        </ModalCustom.Footer>
      </ModalCustom>
    </>
  );
};

export default ModalSlipManualPayment;
